import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import {
  apiFetchCurrentPlans,
  apiFetchBillingHistory,
} from '@dragonfruit/services/apis';
import * as actions from '@dragonfruit/redux/purchaseHistory';
import { actions as errorActions } from '@dragonfruit/redux/error';
import { getRegion } from '@dragonfruit/redux/locale';

import { CONSUMABLE } from '@dragonfruit/constants/planTypes';

export function* fetchPurchaseHistory() {
  const region = yield select(getRegion);

  try {
    const { currentPlans } = yield call(apiFetchCurrentPlans);
    const { billHistories } = yield call(apiFetchBillingHistory);

    const currentPlanList = currentPlans.filter(
      ({ planType }) => planType !== CONSUMABLE
    );

    const historyList = billHistories.map(history =>
      actions.transformHistoryData(history, region)
    );

    yield put(
      actions.fetchPurchaseHistorySuccess({
        currentPlanList,
        historyList,
      })
    );
  } catch (err) {
    yield put(actions.fetchPurchaseHistoryError(err.message));
    yield put(errorActions.sendError(err));
  }
}

export default function*() {
  yield all([takeLatest(actions.FETCH_PURCHASE_HISTORY, fetchPurchaseHistory)]);
}



// WEBPACK FOOTER //
// ./app/sagas/purchaseHistory.js